import { Briefcase, FileText, MessageSquareText, Zap } from 'lucide-react';
import type { AnalyticsOverview } from '@/hooks/useAnalytics';
import { StatCard } from './StatCard';
import { Loading } from '@/components/shared';

interface SummaryStatsProps {
  analyticsData: AnalyticsOverview | undefined;
  isLoading: boolean;
}

export const SummaryStats = ({ analyticsData, isLoading }: SummaryStatsProps) => {
  if (isLoading) {
    return (
      <div className="flex h-32 items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (!analyticsData) {
    return (
      <div className="flex min-h-32 items-center justify-center p-6 text-center text-sm text-muted-foreground">
        No analytics data available for the selected filters.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      <StatCard
        title="Documents uploaded"
        value={analyticsData.total_documents.toLocaleString()}
        icon={<FileText className="size-4" />}
      />
      <StatCard
        title="Tokens used"
        value={analyticsData.total_tokens_used.toLocaleString()}
        icon={<Zap className="size-4" />}
      />
      <StatCard
        title="Active matters"
        value={analyticsData.total_matters}
        icon={<Briefcase className="size-4" />}
      />
      <StatCard
        title="Messages"
        value={analyticsData.total_messages.toLocaleString()}
        icon={<MessageSquareText className="size-4" />}
      />
    </div>
  );
};
